import { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { openModal, closeModal } from '../../redux/slices/modals';

const DiscountCodeRoute = () => {
  const { discountCode } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    if (discountCode) {
      // Navigate to /app/spend while keeping the modal open
      navigate('/app/spend', { replace: true });

      dispatch(
        openModal({
          name: 'discountCode',
          props: {
            discountCode,
            onClose: () => {
              dispatch(closeModal());
            },
          },
        }),
      );
    }
  }, [discountCode, dispatch, navigate]);

  return null;
};

export default DiscountCodeRoute;
